<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="the-light-of-the-world">
<h1>The Light of the World</h1>
<p style="text-indent: 00em;">In summer the place where we live is full of light</p>
<p style="text-indent: 00em;">The sun is upon us and close to us bringing us energy</p>
<p style="text-indent: 00em;">Everywhere there is abundant growth</p>
<p style="text-indent: 00em;">Plants and animals alike are multiplying</p>
<p style="text-indent: 00em;">People are more active and feel more energy</p>
<p style="text-indent: 00em;">They want to be outside and feel the freedom</p>
<p style="text-indent: 00em;">They make plans for the future and feel happier</p>
<p style="text-indent: 00em;">The light from the sun feeds us and feeds the earth.</p><br/>
<p style="text-indent: 00em;">As the earth moves and we get less sun and light</p>
<p style="text-indent: 00em;">There is a slowing down of growth and energy</p>
<p style="text-indent: 00em;">Until when winter is upon us the growing stops</p>
<p style="text-indent: 00em;">The plants and the animals remain dormant</p>
<p style="text-indent: 00em;">We spend less time outside and have less light</p>
<p style="text-indent: 00em;">Our energy recedes and our bodies rest</p>
<p style="text-indent: 00em;">Then as the light from the sun gets nearer again</p>
<p style="text-indent: 00em;">Everywhere slowly awakens and begins to grow again.</p><br/>
<p style="text-indent: 00em;">The world is a finely tuned balance of light and shade</p>
<p style="text-indent: 00em;">Each and every part of the world is unique to its own balance</p>
<p style="text-indent: 00em;">As each part of the world has a different balance of light and shade</p>
<p style="text-indent: 00em;">Our bodies adjust to this light and shade wherever we are born</p>
<p style="text-indent: 00em;">If we move to another part of the world, our bodies and our souls</p>
<p style="text-indent: 00em;">Need time to adjust and to feel at peace with where they are</p>
<p style="text-indent: 00em;">The world is continually adjusting to all that is happening too</p>
<p style="text-indent: 00em;">Above and below the earth all that we destroy and take from within.</p><br/>
<p style="text-indent: 00em;">No wonder there are earthquakes, tsunamis and storms.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch004.vue?a1f8e972